import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../services/apiClient";
import {
  GetStatus,
} from "../../config/config";
import { extractTenantIdFromToken } from "../../helpers/helpers";

export const GetLogStatus = createAsyncThunk(
  "communication/GetStatus",
  async (ParamObject: any, { rejectWithValue }) => {
    try {

      const externalID = ParamObject.externalID;
      const response = await apiClient.get(
        GetStatus,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            ExternalId: externalID,
            'mode': "outlook",
          },
        }
      );

    if (response && response.data) {
  const tenantId = extractTenantIdFromToken();
  const commKey = `communicationId${tenantId}`;
  const timeSlipKey = `timeSlipId${tenantId}`;
  const clarraDocsKey = `clarraDocsId${tenantId}`;

  Office.context.mailbox.item.loadCustomPropertiesAsync(res => {
    if (res.status === Office.AsyncResultStatus.Succeeded) {
       const props = res.value;
      if (response.data.communicationId != null) {
        const newCommId = response.data.communicationId.toString();
        const existingCommunicationId = props.get(commKey);

        console.log(`[DEBUG] Checking custom property ${commKey}:`, existingCommunicationId);

        if (!existingCommunicationId || existingCommunicationId === "null") {
          props.set(commKey, newCommId);
          console.log(`[DEBUG] Setting custom property ${commKey}:`, newCommId);

          props.saveAsync(saveRes => {
            if (saveRes.status === Office.AsyncResultStatus.Succeeded) {
              console.log(`[DEBUG] Successfully updated ${commKey}`);
            } else {
              console.error(`[DEBUG] Failed to save ${commKey}:`, saveRes.error);
            }
          });
        } else {
          console.log(`[DEBUG] ${commKey} already exists, skipping update:`, existingCommunicationId);
        }
      } 
      else {
        // communicationId is null — handle cleanup
        //console.warn(`[DEBUG] communicationId is null for tenant ${tenantId}`);

        const existingCommunicationId = props.get(commKey);
        if (existingCommunicationId) {
          console.log(`[DEBUG] Clearing old communicationId ${existingCommunicationId} for key ${commKey}`);
          props.set(commKey, null); // or props.remove(commKey); in older Office.js versions
          props.saveAsync(saveRes => {
            if (saveRes.status === Office.AsyncResultStatus.Succeeded) {
              console.log(`[DEBUG] Cleared ${commKey} successfully`);
            } else {
              console.error(`[DEBUG] Failed to clear ${commKey}:`, saveRes.error);
            }
          });
        } else {
          console.log(`[DEBUG] No existing ${commKey} to clear`);
        }
      }

       if (response.data.timeSlipId != null) {
        const newTimeSlipId = response.data.timeSlipId.toString();
        const existingTimeSlipId = props.get(timeSlipKey);

       // console.log(`[DEBUG] Checking custom property ${timeSlipKey}:`, existingTimeSlipId);

        if (!existingTimeSlipId || existingTimeSlipId === "null") {
          props.set(timeSlipKey, newTimeSlipId);
         // console.log(`[DEBUG] Setting custom property ${timeSlipKey}:`, newTimeSlipId);

          props.saveAsync(saveRes => {
            if (saveRes.status === Office.AsyncResultStatus.Succeeded) {
              console.log(`[DEBUG] Successfully updated ${timeSlipKey} in custom properties`);
            } else {
              console.error(`[DEBUG] Failed to save updated ${timeSlipKey}:`, saveRes.error);
            }
          });
        } else {
          console.log(`[DEBUG] ${timeSlipKey} already exists in custom properties, skipping update:`, existingTimeSlipId);
        }
      } 
      else {
        // Handle null case — cleanup or log
       // console.warn(`[DEBUG] timeSlipId is null for tenant ${tenantId}`);

        const existingTimeSlipId = props.get(timeSlipKey);
        if (existingTimeSlipId) {
          console.log(`[DEBUG] Clearing old timeSlipId ${existingTimeSlipId} for key ${timeSlipKey}`);
          props.set(timeSlipKey, null); // Or props.remove(timeSlipKey) if Office.js version supports it
          props.saveAsync(saveRes => {
            if (saveRes.status === Office.AsyncResultStatus.Succeeded) {
              console.log(`[DEBUG] Cleared ${timeSlipKey} successfully`);
            } else {
              console.error(`[DEBUG] Failed to clear ${timeSlipKey}:`, saveRes.error);
            }
          });
        } else {
          console.log(`[DEBUG] No existing ${timeSlipKey} to clear`);
        }
      }

      if (response.data.clarraDocsId != null) {
        const newClarraDocsId = response.data.clarraDocsId.toString();
        const existingClarraDocsId = props.get(clarraDocsKey);

        console.log(`[DEBUG] Checking custom property ${clarraDocsKey}:`, existingClarraDocsId);

        if (!existingClarraDocsId || existingClarraDocsId === "null") {
          props.set(clarraDocsKey, newClarraDocsId);
          console.log(`[DEBUG] Setting custom property ${clarraDocsKey}:`, newClarraDocsId);

          props.saveAsync(saveRes => {
            if (saveRes.status === Office.AsyncResultStatus.Succeeded) {
              console.log(`[DEBUG] Successfully updated ${clarraDocsKey} in custom properties`);
            } else {
              console.error(`[DEBUG] Failed to save updated ${clarraDocsKey}:`, saveRes.error);
            }
          });
        } else {
          console.log(`[DEBUG] ${clarraDocsKey} already exists in custom properties, skipping update:`, existingClarraDocsId);
        }
      } 
      else {
        // Handle null clarraDocsId — clean up any old stored value
        console.warn(`[DEBUG] clarraDocsId is null for tenant ${tenantId}`);

        const existingClarraDocsId = props.get(clarraDocsKey);
        if (existingClarraDocsId) {
          console.log(`[DEBUG] Clearing old clarraDocsId ${existingClarraDocsId} for key ${clarraDocsKey}`);
          props.set(clarraDocsKey, null); // or props.remove(clarraDocsKey) if supported
          props.saveAsync(saveRes => {
            if (saveRes.status === Office.AsyncResultStatus.Succeeded) {
              console.log(`[DEBUG] Cleared ${clarraDocsKey} successfully`);
            } else {
              console.error(`[DEBUG] Failed to clear ${clarraDocsKey}:`, saveRes.error);
            }
          });
        } else {
          console.log(`[DEBUG] No existing ${clarraDocsKey} to clear`);
        }
      }

    } else {
      console.error(`[DEBUG] Failed to load custom properties for ${commKey}:`, res.error);
    }
  });
}
      // // ...existing code...
      // if (response && response.data && response.data.communicationId != null) {
      //   const tenantId = extractTenantIdFromToken();
      //   const commKey = `communicationId${tenantId}`;
      //   Office.context.mailbox.item.loadCustomPropertiesAsync(res => {
      //     if (res.status === Office.AsyncResultStatus.Succeeded) {
      //       const props = res.value;
      //       const existingCommunicationId = props.get(commKey);
      //       console.log(`[DEBUG] Checking custom property ${commKey}:`, existingCommunicationId);
      //       if (!existingCommunicationId || existingCommunicationId === "null") {
      //         props.set(commKey, response.data.communicationId.toString());
      //         console.log(`[DEBUG] Setting custom property ${commKey}:`, response.data.communicationId);

      //         props.saveAsync(saveRes => {
      //           if (saveRes.status === Office.AsyncResultStatus.Succeeded) {
      //             console.log(`[DEBUG] Successfully updated ${commKey} in custom properties`);
      //           } else {
      //             console.error(`[DEBUG] Failed to save updated ${commKey}:`, saveRes.error);
      //           }
      //         });
      //       } else {
      //         console.log(`[DEBUG] ${commKey} already exists in custom properties, not updating:`, existingCommunicationId);
      //       }
      //     } else {
      //       console.error(`[DEBUG] Failed to load custom properties for ${commKey} update:`, res.error);
      //     }
      //   });
      // }
      // // ...repeat for timeSlipId and clarraDocsId...

      // // ...existing code...
      // if (response && response.data && response.data.timeSlipId != null) {
      //   const tenantId = extractTenantIdFromToken();
      //   const timeSlipKey = `timeSlipId${tenantId}`;
      //   Office.context.mailbox.item.loadCustomPropertiesAsync(res => {
      //     if (res.status === Office.AsyncResultStatus.Succeeded) {
      //       const props = res.value;
      //       const existingTimeSlipId = props.get(timeSlipKey);
      //       console.log(`[DEBUG] Checking custom property ${timeSlipKey}:`, existingTimeSlipId);
      //       if (!existingTimeSlipId || existingTimeSlipId === "null") {
      //         props.set(timeSlipKey, response.data.timeSlipId.toString());
      //         console.log(`[DEBUG] Setting custom property ${timeSlipKey}:`, response.data.timeSlipId);

      //         props.saveAsync(saveRes => {
      //           if (saveRes.status === Office.AsyncResultStatus.Succeeded) {
      //             console.log(`[DEBUG] Successfully updated ${timeSlipKey} in custom properties`);
      //           } else {
      //             console.error(`[DEBUG] Failed to save updated ${timeSlipKey}:`, saveRes.error);
      //           }
      //         });
      //       } else {
      //         console.log(`[DEBUG] ${timeSlipKey} already exists in custom properties, not updating:`, existingTimeSlipId);
      //       }
      //     } else {
      //       console.error(`[DEBUG] Failed to load custom properties for ${timeSlipKey} update:`, res.error);
      //     }
      //   });
      // }

      // if (response && response.data && response.data.clarraDocsId != null) {
      //   const tenantId = extractTenantIdFromToken();
      //   const clarraDocsKey = `clarraDocsId${tenantId}`;
      //   Office.context.mailbox.item.loadCustomPropertiesAsync(res => {
      //     if (res.status === Office.AsyncResultStatus.Succeeded) {
      //       const props = res.value;
      //       const existingClarraDocsId = props.get(clarraDocsKey);
      //       console.log(`[DEBUG] Checking custom property ${clarraDocsKey}:`, existingClarraDocsId);
      //       if (!existingClarraDocsId || existingClarraDocsId === "null") {
      //         props.set(clarraDocsKey, response.data.clarraDocsId.toString());
      //         console.log(`[DEBUG] Setting custom property ${clarraDocsKey}:`, response.data.clarraDocsId);

      //         props.saveAsync(saveRes => {
      //           if (saveRes.status === Office.AsyncResultStatus.Succeeded) {
      //             console.log(`[DEBUG] Successfully updated ${clarraDocsKey} in custom properties`);
      //           } else {
      //             console.error(`[DEBUG] Failed to save updated ${clarraDocsKey}:`, saveRes.error);
      //           }
      //         });
      //       } else {
      //         console.log(`[DEBUG] ${clarraDocsKey} already exists in custom properties, not updating:`, existingClarraDocsId);
      //       }
      //     } else {
      //       console.error(`[DEBUG] Failed to load custom properties for ${clarraDocsKey} update:`, res.error);
      //     }
      //   });
      // }
      // ...existing code...


      return response ? response.data : null;
    } catch (error) {
      return rejectWithValue(error.response); // Return error message
    }
  }
);

const logStatusSlice = createSlice({
  name: "logStatus",
  initialState: {
    logStatus: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetLogStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetLogStatus.fulfilled, (state, action) => {

        state.loading = false;
        state.logStatus = action.payload;
      })
      .addCase(GetLogStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default logStatusSlice.reducer;
